module.exports = __webpack_public_path__ + "img/cappadocia.16fe59aa.jpg";